const initialState = {
  loading: false,
  payload: null,
  error: null
}

export default function saveReviewReducer(state = initialState, action) {
  switch (action.type) {
    case 'SAVE_REVIEW_BEGIN':
      return {
        ...state,
        loading: true,
        error: null
      }
    case 'SAVE_REVIEW_SUCCESS':
      return {
        ...state,
        loading: false,
        payload: action.payload
      }
    case 'SAVE_REVIEW_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }
    default:
      return state
  }
}
